import { AiOutlineCloseCircle } from 'react-icons/ai';
import GeneralInput from "../../common/GeneralInput";
import { ChangeEvent, FormEvent, useState } from "react";
import * as CommonTypes from "../../../types/common.types";
import AdminService from "../../../services/admin.service";
import { useAdmin } from "../../../context/admin";
import { useGlobal } from "../../../context/global";
import Modal from "../../common/Modal";


export default function CreateAlly() {
    const { setMessage, setIsLoading } = useGlobal()
    const { setIsCreateAllyModalOpen } = useAdmin()
    const [data, setData] =  useState<Partial<CommonTypes.Ally>>({})
    function onChange(e: ChangeEvent<HTMLInputElement>) {
        const name = e.target.name
        const value = e.target.value
        setData((prevData) => ({...prevData, [name]: value}))
    }

    async function onSubmit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        console.log(data)
        setIsLoading(true)
        try {
            await AdminService.registerAlly(data)
            window.location.reload()
        } catch (error: any) {
            if (error.response?.data) {
                setMessage({
                    type: 'error',
                    content: error.response.data
                })
                setTimeout(() => setMessage(undefined), 2500)
            }
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal onSubmit={onSubmit}>
            <h1>Create new ally</h1>
            <GeneralInput
            label="Name"
            value={data.name || ''}
            onChange={onChange}
            placeholder="Nuevo aliado"
            name="name"
            style={{marginBottom: '20px'}}
            required
            />
            <GeneralInput
            label="Email"
            value={data.email || ''}
            onChange={onChange}
            placeholder="jose@aliado.com"
            name="email"
            style={{marginBottom: '20px'}}
            required
            />
            <GeneralInput
            type="number"
            name="sell_commission"
            value={data.sell_commission || ''}
            label="Seller commission %"
            min={0}
            max={100}
            style={{marginBottom: '20px'}}
            onChange={onChange}
            placeholder="10%"
            />
            <GeneralInput
            type='string'
            label='Password'
            name='password'
            value={data.password}
            style={{marginBottom: '20px'}}
            onChange={onChange}
            placeholder="123asd"
            />
            <div className="actions">
                <button type="submit">Create ally</button>
            </div>
            <div className="close" title="close"
            onClick={() => setIsCreateAllyModalOpen(false)}
            >
                <AiOutlineCloseCircle/>
            </div>
        </Modal>
    )
}
